(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dng-complete-look"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('dng-look-builder')) {
  customElements.define('dng-look-builder', class extends HTMLElement {
    connectedCallback() {
      if (this.initialised) return;
      this.initialised = true;
      const config = JSON.parse(this.querySelector('[data-config]').textContent);
      this.t = config.strings;
      this.currency = config.currency;
      this.items = [];
      this.busy = false;
      this.storageKey = 'dng-saved-looks-v1';
      this.money = value => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:this.currency}).format(value / 100);
      this.addEventListener('click', event => {
        const button = event.target.closest('button[data-action]');
        if (!button || this.busy) return;
        const action = button.dataset.action;
        if (action === 'add') this.add(button.closest('[data-product]'));
        if (action === 'remove') {this.items = this.items.filter(item => item.id !== button.dataset.id); this.render();}
        if (action === 'preview') this.preview(this.items.find(item => item.id === button.dataset.id));
        if (action === 'save') this.save();
        if (action === 'saved') {const panel=this.querySelector('[data-saved-panel]');panel.hidden=!panel.hidden;if(!panel.hidden)this.saved();}
        if (action === 'restore') this.restore(button.dataset.id);
        if (action === 'delete') this.deleteSaved(button.dataset.id);
        if (action === 'more') this.more(button);
        if (action === 'checkout') this.checkout();
      });
      this.addEventListener('change', event => {
        if (!event.target.matches('[data-variant]')) return;
        const card=event.target.closest('[data-product]');
        const option=event.target.selectedOptions[0];
        card.querySelector('[data-action="add"]').disabled=!option.value || option.disabled;
        if(option.value)card.querySelector('[data-card-price]').textContent=this.money(Number(option.dataset.price));
      });
      this.render();
    }
    node(tag, text, className) {const el=document.createElement(tag);if(text!==undefined)el.textContent=text;if(className)el.className=className;return el;}
    button(text, action, id, className) {const b=this.node('button',text,className);b.type='button';b.dataset.action=action;if(id)b.dataset.id=id;return b;}
    status(text) {this.querySelector('[data-status]').textContent=text;}
    safeImage(src) {try{const u=new URL(src,location.origin);return ['https:','http:'].includes(u.protocol)?u.href:'';}catch{return '';}}
    preview(item) {
      const box=this.querySelector('[data-preview]');box.replaceChildren();
      if(!item){const p=this.node('p',this.t.empty);p.append(this.node('small',this.t.empty_hint));box.append(p);return;}
      const url=this.safeImage(item.image);
      if(url){const img=this.node('img');img.src=url;img.alt=item.title;box.append(img);}else box.append(this.node('p',item.title));
    }
    add(card) {
      const option=card.querySelector('[data-variant]').selectedOptions[0];
      if(!option.value||option.disabled){this.status(this.t.pick);return;}
      if(this.items.some(item=>item.id===option.value)){this.status(this.t.duplicate);return;}
      this.items.push({id:option.value,handle:card.dataset.handle,title:card.dataset.title,variant:option.textContent.trim(),price:Number(option.dataset.price),image:option.dataset.image||card.dataset.image});
      this.render();this.status(this.t.added);
    }
    render() {
      const list=this.querySelector('[data-selected]');list.replaceChildren();
      this.items.forEach(item=>{
        const row=this.node('div',undefined,'dlb-selected-item');
        const preview=this.button('', 'preview',item.id,'dlb-thumb');preview.setAttribute('aria-label',this.t.preview+' '+item.title);
        const url=this.safeImage(item.image);if(url){const img=this.node('img');img.src=url;img.alt='';preview.append(img);}else { const svg=document.createElementNS('http://www.w3.org/2000/svg','svg'); svg.setAttribute('class','dng-line-icon'); svg.setAttribute('viewBox','0 0 24 24'); svg.setAttribute('aria-hidden','true'); svg.innerHTML='<path d="M6 18 18 6M6 6h12v12"/>'; preview.append(svg); }
        const text=this.node('div');text.append(this.node('strong',item.title),this.node('small',item.variant+' · '+this.money(item.price)),this.button(this.t.remove,'remove',item.id,'dlb-remove'));row.append(preview,text);list.append(row);
      });
      this.querySelector('[data-total]').textContent=this.money(this.items.reduce((total,item)=>total+item.price,0));
      const ready=this.items.length>=Number(this.dataset.min);
      this.querySelector('[data-ready]').textContent=ready?this.t.ready:this.t.need.replace('{n}',this.dataset.min);
      this.querySelector('[data-action="checkout"]').disabled=!ready||this.busy;
      this.querySelector('[data-action="save"]').disabled=!ready||this.busy;
      this.preview(this.items.at(-1));
    }
    getSaved() {const entries=JSON.parse(localStorage.getItem(this.storageKey)||'[]');return Array.isArray(entries)?entries.filter(e=>e&&typeof e.id==='string'&&Array.isArray(e.items)):[];}
    save() {
      if(this.items.length<Number(this.dataset.min))return;
      try{const entries=this.getSaved();entries.unshift({id:Date.now().toString()+'-'+Math.random().toString(36).slice(2),items:this.items.map(({id,handle})=>({id,handle}))});localStorage.setItem(this.storageKey,JSON.stringify(entries.slice(0,20)));this.status(this.t.saved_ok);this.saved();}catch{this.status(this.t.storage_error);}
    }
    saved() {
      const list=this.querySelector('[data-saved-list]');list.replaceChildren();
      try{const entries=this.getSaved();if(!entries.length)list.append(this.node('p',this.t.no_saved));entries.forEach((entry,index)=>{const row=this.node('div',undefined,'dlb-saved-row');row.append(this.node('span',this.t.saved_name+' '+(index+1)+' · '+entry.items.length),this.button(this.t.restore,'restore',entry.id),this.button(this.t.delete,'delete',entry.id));list.append(row);});}catch{this.status(this.t.storage_error);}
    }
    deleteSaved(id) {try{localStorage.setItem(this.storageKey,JSON.stringify(this.getSaved().filter(e=>e.id!==id)));this.saved();}catch{this.status(this.t.storage_error);}}
    async restore(id) {
      this.busy=true;this.render();this.status(this.t.loading);
      try{
        const entry=this.getSaved().find(e=>e.id===id);if(!entry)throw Error();
        const results=await Promise.all(entry.items.map(async saved=>{
          const response=await fetch(this.dataset.root+'products/'+encodeURIComponent(saved.handle)+'.js');
          if(response.status===404)return null;if(!response.ok)throw Error();
          const product=await response.json();const variant=product.variants.find(v=>String(v.id)===String(saved.id));
          if(!variant?.available)return null;
          return {id:String(variant.id),handle:product.handle,title:product.title,variant:variant.title,price:variant.price,image:variant.featured_image?.src||product.featured_image||''};
        }));
        const restored=results.filter(Boolean);if(restored.length){this.items=restored;this.status(this.t.restored);}else this.status(this.t.unavailable);
      }catch{this.status(this.t.error);}finally{this.busy=false;this.render();}
    }
    async more(button) {
      const label=button.textContent;button.disabled=true;button.textContent=this.t.loading;
      try{
        const url=new URL(button.dataset.next,location.origin);url.searchParams.set('section_id',this.dataset.section);
        const response=await fetch(url);if(!response.ok)throw Error();
        const doc=new DOMParser().parseFromString(await response.text(),'text/html');const nextSection=doc.getElementById(this.id);if(!nextSection)throw Error();
        const cards=nextSection.querySelectorAll('[data-catalog] > [data-product]');
        cards.forEach(card=>{if(!this.querySelector('[data-product="'+card.dataset.product+'"]'))this.querySelector('[data-catalog]').append(document.importNode(card,true));});
        const next=nextSection.querySelector('[data-action="more"]');if(next)button.dataset.next=next.dataset.next;else button.remove();
      }catch{this.status(this.t.load_error);}finally{button.disabled=false;button.textContent=label;}
    }
    async checkout() {
      if(this.items.length<Number(this.dataset.min)||this.busy)return;
      this.busy=true;this.render();this.status(this.t.loading);
      try{
        const response=await fetch(this.dataset.root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:this.items.map(item=>({id:item.id,quantity:1}))})});
        const result=await response.json();
        if(!response.ok){this.status((typeof result.description==='string'?result.description+' ':'')+this.t.cart_error);this.busy=false;this.render();return;}
        location.assign(this.dataset.root+'checkout');
      }catch{this.status(this.t.cart_error);this.busy=false;this.render();}
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dng-header"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dng-site-header')) {
    customElements.define('dng-site-header', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.addEventListener('keydown', (event) => {
          if (event.key !== 'Escape') return;
          const open = this.querySelector('.dngh__actions > details[open]');
          if (open) { open.open = false; open.querySelector('summary').focus(); event.preventDefault(); }
        }, { signal });
        // Keyboard opening (Enter/Space on the icon) also moves focus into the field.
        this.addEventListener('toggle', (event) => {
          const search = event.target;
          if (!search.matches?.('.dngh__search') || !search.open) return;
          const input = search.querySelector('input[name="q"]');
          if (document.activeElement !== input) input?.focus();
        }, { signal, capture: true });
        document.addEventListener('click', (event) => {
          if (!this.contains(event.target)) this.querySelectorAll('.dngh__actions > details[open]').forEach((panel) => { panel.open = false; });
        }, { signal });
        // Page progress hairline. The page may scroll inside .page-wrapper, so
        // listen in the capture phase and read whichever element is scrolling.
        let frame = 0;
        const progress = () => {
          frame = 0;
          const wrapper = document.querySelector('.page-wrapper');
          const el = wrapper && wrapper.scrollHeight > wrapper.clientHeight + 1 ? wrapper : document.documentElement;
          const max = el.scrollHeight - el.clientHeight;
          const top = el === wrapper ? wrapper.scrollTop : window.scrollY;
          this.style.setProperty('--dngh-progress', max > 0 ? (top / max).toFixed(4) : '0');
        };
        const queue = () => { if (!frame) frame = requestAnimationFrame(progress); };
        document.addEventListener('scroll', queue, { signal, capture: true, passive: true });
        window.addEventListener('resize', queue, { signal, passive: true });
        progress();
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
